<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h1 style="font-size: 18px !important;" mat-dialog-title>
  Lead History
  <img class="close-button" (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h1>

<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="row mb-3 mt-3" *ngIf="leadHistorydDetails.length == 0">
        <div class="col">
          <p style="text-align: center;">No data available!</p>
        </div>
      </div>
      <div class="row mb-3" *ngIf="leadHistorydDetails.length > 0">
        <div class="col">
          <button class="btn btn-outline btn-sm mr-2 mt-1"><img style="height: 17px;" alt=""
              [src]="bucketurl + '/images/filter.png'" alt=""></button>
          <button *ngFor="let data of filters" [ngClass]="{'selected': isSelected(data) }"
            class="btn btn-outline-secondary btn-sm mr-2 mt-1" (click)="selectFilter(data)">{{data}}</button>
        </div>
      </div>
      <div class="timeline" *ngFor="let history of leadHistorydDetails">
        <div class="day" *ngFor="let event of history.data;let i = index">
          <div class="day-label"> <span *ngIf="i == 0"> {{ history.day }}</span></div>
          <div class="timeline-item"
            *ngIf="event?.activity_flag !== 'testRide' && event?.activity_flag !== 'quotation'">
            <div class="item-header ml-2 mt-2">
              <h5 class="lead text-animation {{event?.activity_flag}}"> <img
                  class="header-img imgsrc-{{event?.activity_flag}} flip-animation" src="" alt="">
                <span class=""> {{event?.output_data?.text}}</span>
              </h5>
            </div>
            <hr>
            <div class="content-container">
              <div class="content-body">
                <p *ngIf="event?.activity_flag == 'leadCaptured'"><span class="head-text">Name:</span> <span
                    class="data-text"> {{event?.output_data?.name}}</span></p>
                <p *ngIf="event?.activity_flag == 'leadCaptured'"><span class="head-text">Email ID:</span><span
                    class="data-text"> {{event?.output_data?.email}}</span></p>
                <p *ngIf="event?.activity_flag == 'leadCaptured'"><span class="head-text">Phone Number:</span><span
                    class="data-text"> {{event?.output_data?.mobile}}</span></p>
                <p *ngIf="event?.activity_flag == 'leadCaptured'"><span class="head-text">Source:</span><span
                    class="data-text"> {{event?.output_data?.leadSource}}</span></p>
                <p *ngIf="event?.activity_flag == 'leadCaptured'"><span class="head-text">Stage:</span><span
                    class="data-text"> {{event?.stage}}</span></p>

                <!-- <p *ngIf="event?.activity_flag == 'movedToAssigned'"><span class="head-text">Assigned By:</span><span
                    class="data-text"> {{event?.output_data?.by?.first_name}}</span></p> -->
                <p *ngIf="event?.activity_flag == 'movedToAssigned'"><span class="head-text">Assigned To:</span><span
                    class="data-text"> {{event?.output_data?.assignToData?.first_name}}</span></p>
                <p *ngIf="event?.activity_flag == 'movedToAssigned'"><span class="head-text">Interest level:</span><span
                    class="data-text"> {{event?.interest_level ? event?.interest_level :'-' }}</span></p>
                <p *ngIf="event?.activity_flag == 'movedToAssigned' || event?.activity_flag == 'movedToOpportunity'">
                  <span class="head-text">Customer
                    Requirement:</span><span class="data-text"> {{event?.customer_requirement ?
                    event?.customer_requirement :'-' }}</span>
                </p>

                <p *ngIf="event?.activity_flag == 'movedToFollowup' || event?.activity_flag == 'followupAction'"><span
                    class="head-text">Follow up
                    Reason:</span><span class="data-text"> {{event?.followup_reason ?
                    event?.followup_reason :'-' }}</span></p>
                <p *ngIf="event?.activity_flag == 'movedToFollowup' || event?.activity_flag == 'followupAction'">
                  <span class="head-text">Follow up
                    Date & Time:</span><span class="data-text"> {{ event?.next_followup_date
                    ? (event.next_followup_date | date:'dd/MM/yyyy hh:mm a':'Asia/Kolkata')
                    : '-'
                    }}</span>
                </p>

                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Mode of Contact:</span><span class="data-text"> {{
                    event?.actual_mode_of_contact}}</span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Enquiry Stage:</span><span class="data-text"> {{
                    event?.actual_sales_followup_reason}}</span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Actual Followup Date:</span><span class="data-text">
                    {{ event?.actual_followup_date
                    ? (event.actual_followup_date | date:'dd/MM/yyyy hh:mm a':'Asia/Kolkata')
                    : '-'
                    }}
                  </span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Next Followup Date:</span><span class="data-text">{{ event?.next_followup_date
                    ? (event.next_followup_date | date:'dd/MM/yyyy hh:mm a':'Asia/Kolkata')
                    : '-'
                    }} </span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Action:</span><span class="data-text"> {{
                    event?.mode_of_contact}}</span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">FollowUp:</span><span class="data-text"> {{
                    event?.sales_followup_reason}}</span>
                </p>
                <p
                  *ngIf="event?.activity_flag == 'leadFollowup' || event?.activity_flag == 'movedToPostponed' ||event?.activity_flag=='movedToLost'">
                  <span class="head-text">Remarks:</span><span class="data-text"> {{
                    event?.followup_remarks}}</span>
                </p>
                <!-- <p
                  *ngIf="event?.activity_flag == 'movedToFollowup' || event?.activity_flag == 'followupAction' || event?.activity_flag == 'movedToOpportunity' || event?.activity_flag == 'updateLeadAction'">
                  <span class="head-text">Follow up
                    Date & Time:</span><span class="data-text"> {{event?.next_followup_date ?
                    (event?.next_followup_date | date:'dd-MM-yyyy, hh:mm a') :'-' }}</span>
                </p> -->

                <p *ngIf="event?.activity_flag == 'movedToJunk'"><span class="head-text">Junk Reason:</span><span
                    class="data-text"> {{event?.junk_reason ?
                    event?.junk_reason :'-' }}</span></p>

                <p *ngIf="event?.activity_flag == 'movedToNonSales'"><span class="head-text">Reason:</span><span
                    class="data-text"> {{event?.non_sales_category ?
                    event?.non_sales_category :'-' }}</span></p>

                <p
                  *ngIf="event?.activity_flag == 'movedToLost' || event?.activity_flag == 'movedToDrop' || event?.activity_flag == 'movedToOpportunityLost'">
                  <span class="head-text">Lost Reason:</span><span class="data-text"> {{event?.lost_reason ?
                    event?.lost_reason :'-' }}</span>
                </p>

                <p *ngIf="event?.activity_flag == 'movedToNoResponse' || event?.activity_flag == 'noResponseAction'">
                  <span class="head-text">No Response
                    Reason:</span><span class="data-text"> {{event?.no_response_reason ?
                    event?.no_response_reason :'-' }}</span>
                </p>

                <p *ngIf="event?.activity_flag == 'movedToOpportunity'"><span class="head-text">Customer Interest
                    Level:</span><span class="data-text"> {{event?.customer_interest ?
                    event?.customer_interest :'-' }}</span></p>
                <p *ngIf="event?.activity_flag == 'movedToOpportunity'"><span class="head-text">Likelihood to
                    purchase:</span><span class="data-text"> {{event?.likelihood_to_purchase ?
                    event?.likelihood_to_purchase :'-' }}</span></p>


                <p *ngIf="event?.activity_flag == 'movedToBooking'">
                  <span class="head-text">Booked Date:</span><span class="data-text"> {{event?.booking_date
                    ?
                    (event?.booking_date | date:'dd-MM-yyyy') :'-' }}</span>
                </p>
                <p *ngIf="event?.activity_flag == 'movedToBooking'">
                  <span class="head-text">Booking Amount:</span><span class="data-text"> {{event?.booking_amount
                    ? event?.booking_amount :'-' }}</span>
                </p>
                <p *ngIf="event?.activity_flag == 'movedToBooking' || event?.activity_flag == 'movedToRetailed'">
                  <span class="head-text">Payment Method:</span><span class="data-text"> {{event?.payment_method
                    ? event?.payment_method :'-' }}</span>
                </p>
                <p *ngIf="event?.activity_flag == 'movedToBooking'">
                  <span class="head-text">Delivery Preference:</span><span class="data-text">
                    {{event?.delivery_preference
                    ? event?.delivery_preference :'-' }}</span>
                </p>

                <p *ngIf="event?.activity_flag == 'movedToRetailed'">
                  <span class="head-text">Retailed Date & Time:</span><span class="data-text"> {{event?.retail_date_time
                    ?
                    (event?.retail_date_time | date:'dd-MM-yyyy, hh:mm a') :'-' }}</span>
                </p>
                <p *ngIf="event?.activity_flag == 'movedToRetailed'">
                  <span class="head-text">Paid Amount:</span><span class="data-text"> {{event?.paid_amount
                    ? event?.paid_amount :'-' }}</span>
                </p>
                <!-- <p *ngIf="event?.activity_flag == 'updateLeadAction'">
                  <span class="head-text">Product category:</span><span class="data-text">
                    {{event?.output_data?.productCategory
                    ? event?.output_data?.productCategory :'-' }}</span>
                </p> -->
                <!-- <p *ngIf="event?.activity_flag == 'updateLeadAction'">
                  <span class="head-text">Product Model:</span><span class="data-text">
                    {{event?.output_data?.productModel
                    ? event?.output_data?.productModel :'-' }}</span>
                </p> -->
                <ng-container *ngIf="event?.activity_flag == 'updateLeadAction'">
                  <ng-container *ngIf="event?.output_data?.newFields?.length > 0">
                    <span class="head-text">New:</span>
                    <p *ngFor="let data of event?.output_data?.newFields; let n = index;">
                      <span class="data-text">
                        {{n+1}}. {{ data}}</span>
                    </p>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="event?.activity_flag == 'updateLeadAction'">
                  <ng-container *ngIf="event?.output_data?.updatedFields?.length > 0">
                    <span class="head-text">Updated:</span>
                    <p *ngFor="let data of event?.output_data?.updatedFields; let k =index">
                      <!-- <span class="head-text">Updated Filed {{k +1}}:</span> -->
                      <span class="data-text">
                        {{k+1}}. {{ data}}</span>
                    </p>
                  </ng-container>
                </ng-container>

                <p
                  *ngIf="event?.activity_flag == 'leadCaptured' || event?.activity_flag == 'movedToAssigned' || event?.activity_flag == 'movedToNoResponse' || event?.activity_flag == 'movedToFollowup' || event?.activity_flag == 'followupAction' || event?.activity_flag == 'movedToJunk' || event?.activity_flag == 'movedToLost' || event?.activity_flag == 'movedToDrop' || event?.activity_flag == 'movedToNoResponse' || event?.activity_flag == 'noResponseAction' || event?.activity_flag == 'movedToOpportunity' || event?.activity_flag == 'updateLeadAction' || event?.activity_flag == 'movedToOpportunityLost' || event?.activity_flag == 'movedToNonSales'">
                  <span class="head-text">Remarks:</span><span class="data-text"> {{event?.remarks ? event?.remarks :
                    '-'}}</span>
                </p>
              </div>
              <div class="meta-info">
                <p><img class="meta-img" src="/assets/images/history-calender.png" alt=""> <span
                    class="head-text">Action Date:</span><span class="data-text"> {{event?.output_data?.time ?
                    event?.output_data?.time.split('/')[0] : ''}}</span></p>
                <p><img class="meta-img" src="/assets/images/history-time.png" alt=""> <span class="head-text">Action
                    Time:</span><span class="data-text"> {{event?.output_data?.time ?
                    event?.output_data?.time.split('/')[1] : ''}}</span></p>
                <!-- <p><img class="meta-img" src="/assets/images/history-user.png" alt="">
                  <span class="head-text" *ngIf="event?.output_data?.by?.role_id == 4">Tele Caller:</span>
                  <span class="head-text" *ngIf="event?.output_data?.by?.role_id == 3">Sales Manager:</span>
                  <span class="data-text">{{event?.output_data?.by?.first_name}}</span>
                </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>